export function isNumeric(val: string | number): val is number | string {
	// Number(val) convert "40" в 40, а "hello" в NaN.
	// String(val).trim() !== '' check empty strings that Number() converts to 0.
	return typeof val !== 'object' && String(val).trim() !== '' && Number.isFinite(Number(val));
}
